import { createAction } from '@reduxjs/toolkit';

export const campaignBreadCrumbsActions = {
  navigateTo: createAction<{ navigateTo: string }>('CampaignBreadCrumbs/NavigateTo'),
};
